import { request } from '../http';

export type MaintenanceCleanupPreviewResult = {
  action: string;
  eligibleCount: number;
  matched?: number;
  canClear?: boolean;
  olderThanDays?: number | null;
  breakdown?: Record<string, number>;
};

export type MaintenanceCleanupExecuteResult = {
  status: string;
  deleted: number;
  deletedNotifications?: number;
  deletedCustomerActivity?: number;
  executionMs: number;
  breakdown?: Record<string, number>;
};

export const maintenanceService = {
  notificationsCleanupPreview: (payload: { older_than_days?: number } = {}) =>
    request<MaintenanceCleanupPreviewResult>('/maintenance/notifications/cleanup/preview', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
  notificationsCleanup: (payload: { older_than_days?: number } = {}) =>
    request<MaintenanceCleanupExecuteResult>('/maintenance/notifications/cleanup', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
